export enum SeturLoyaltyPointTransactionTypes {
  KREDI_KARTI_ILE_PUAN_CEVIR = 'KREDI_KARTI_ILE_PUAN_CEVIR',
  DIGER_MARKALARDAN_PUAN_CEVIR = 'DIGER_MARKALARDAN_PUAN_CEVIR',
  HARCAMA_ILE_PUAN_KAZAN = 'HARCAMA_ILE_PUAN_KAZAN',
  KREDI_KARTI_ILE_PUAN_SATIN_AL = 'KREDI_KARTI_ILE_PUAN_SATIN_AL',
  HEDIYE_KARTTAN_PUAN_KAZAN = 'HEDIYE_KARTTAN_PUAN_KAZAN',
  HARCANAN_PUANI_GERI_YUKLE = 'HARCANAN_PUANI_GERI_YUKLE',
  SETUR_PUAN_HARCA = 'SETUR_PUAN_HARCA',
  KAZANILAN_PUANI_IPTAL_ET_URUN_IPTALI = 'KAZANILAN_PUANI_IPTAL_ET_URUN_IPTALI',
  KAZANILAN_PUANI_IPTAL_ET_URUN_DEGISIKLIGI = 'KAZANILAN_PUANI_IPTAL_ET_URUN_DEGISIKLIGI',
  HARCANAN_PUANI_GERI_YUKLE_URUN_DEGISIKLIGI = 'HARCANAN_PUANI_GERI_YUKLE_URUN_DEGISIKLIGI',
  HARCANAN_PUANI_GERI_YUKLE_URUN_IPTALI = 'HARCANAN_PUANI_GERI_YUKLE_URUN_IPTALI',
  DINAMIK_KUPON_PUAN_KAZANDI = 'DINAMIK_KUPON_PUAN_KAZANDI',
  KUPON_PUAN_HARCAMASI = 'KUPON_PUAN_HARCAMASI',
  REFERANS_VEREREK_KUPON_PUAN_KAZANDI = 'REFERANS_VEREREK_KUPON_PUAN_KAZANDI',
  HOSGELDIN_KUPON_PUAN_KAZANDI = 'HOSGELDIN_KUPON_PUAN_KAZANDI',
  KULUP_KUPON_PUAN_KAZANDI = 'KULUP_KUPON_PUAN_KAZANDI',
  REFERANS_ALARAK_KUPON_PUAN_KAZANDI = 'REFERANS_ALARAK_KUPON_PUAN_KAZANDI',
  HARCANAN_KUPONU_GERI_YUKLE_URUN_IPTALI = 'HARCANAN_KUPONU_GERI_YUKLE_URUN_IPTALI',
  HARCANAN_KUPONU_GERI_YUKLE_URUN_DEGISIKLIGI = 'HARCANAN_KUPONU_GERI_YUKLE_URUN_DEGISIKLIGI',
  HARCAMA_GERI_YUKLE_CEZA_YANSIMASI = 'HARCAMA_GERI_YUKLE_CEZA_YANSIMASI',
  ADMIN_TARAFINDAN_MANUEL_PUAN_YUKLENDI = 'ADMIN_TARAFINDAN_MANUEL_PUAN_YUKLENDI',
  VOUCHER_NO_ILE_MANUEL_PUAN_YUKLENDI = 'VOUCHER_NO_ILE_MANUEL_PUAN_YUKLENDI',
}
